<i class="far fa-exclamation" data-fa-symbol="exclamation-simple"></i>

<div class="wrapper">
  <div class="table-container">
    <qm-filters
      [filterDefinitions]="trainTypeFilters"
      (filtersChanged)="filtersChanged($event)"
      [position]="'left'" style="width:100%;">
    </qm-filters>
    <table class="table table-sm table-hover" *qmLoading="loading">
      <thead>
      <tr>
        <th [style.width]="columnWidths.train">
          {{'Train' | translate}}
        </th>
        <th [style.width]="columnWidths.route">
          {{'Route' | translate}}
        </th>
        <th colspan="2">
          {{'Status information' | translate}}
        </th>
      </tr>
      </thead>
      <tbody>
      <ng-template ngFor let-train [ngForOf]="displayedTrains | slice:0:listLimit">
        <tr
          class="clickable"
          [ngClass]="getRowClass | applyFunction:train"
          *ngIf="trainVisible | applyFunction:train:trainFilter"
          (click)="openTrainInfo(train)"
        >
          <td [style.width]="columnWidths.train">
            {{train.title}} {{train.subTitle}}
          </td>
          <td [style.width]="columnWidths.route">
            {{train.depStation}} - {{train.arrStation}}
          </td>
          <!-- Status information -->
          <td [style.width]="columnWidths.time">
            <span class="badge badge-pill" [ngClass]="'badge-' + train.status">{{train.calculatedDelta}}</span>
          </td>
          <td>
            <span
              class="badge badge-warning clickable"
              ngbTooltip="{{ 'See VAK info from cargo manifest' | translate }}"
              *ngIf="train.vak"
              (click)="openCargoInfo(train)"
            >
              VAK
            </span>
            <span
              *ngFor="let cause of train.causes | qmMapValues"
              (click)="selectAlarmOverlayTrain(train); alarmDetails.toggle($event); $event.stopPropagation()"
              class="clickable"
              ngbTooltip="{{ 'Open alarm details' | translate }}"
            >
              {{ cause.val.determinedKonegisCauseCode }}
            </span>
            <!-- TODO: show icon for other conflicts as well when available -->
            <span
              *ngIf="hasActiveConflictOrTechnicalAlarms | applyFunction:train"
              (click)="selectAlarmOverlayTrain(train); alarmDetails.toggle($event); $event.stopPropagation()"
              ngbTooltip="{{'Equipment conflict' | translate}}"
              class="clickable"
              ngbTooltip="{{ 'Open alarm details' | translate }}"
            >
              <ng-container *ngTemplateOutlet="conflictIcon"></ng-container>
            </span>
          </td>
        </tr>
      </ng-template>

      <div [ngStyle]="{width: '100%', padding: '1em', textAlign: 'center'}">
        <button
          *ngIf="listLimit < displayedTrains.length"
          (click)="onLoadMoreBtnClicked()"
          class="btn btn-outline-info">
          {{ 'Load more' | translate }}
        </button>
      </div>

      </tbody>
    </table>
  </div>
</div>

<qm-overlay-panel #alarmDetails [stickTo]="'left-bottom'" [appendTo]="'body'" [dismissable]="true" [skipFirstClick]="false">
    <div class="card hover-container" *ngIf="alarmOverlaySelectedTrain">
        <div class="card-header">
          {{ alarmOverlaySelectedTrain.title }} {{ alarmOverlaySelectedTrain.subTitle}} {{ 'Status' | translate }}
        </div>
        <div class="card-body">
          <ng-container *ngIf="alarmOverlaySelectedTrain.causes && alarmOverlaySelectedTrain.causes.size > 0; else noCauseCodes;">
              <h5>{{ 'Reason code details' | translate }} </h5>
              <span *ngFor="let cause of alarmOverlaySelectedTrain.causes | qmMapValues">
                  {{ cause.val.determinedKonegisCauseCode }} {{ cause.val.liviCauseCode?.categoryName }}
                  <div class="rounded border border-danger" style="display: block; width: 4em; text-align: center">
                    <a href="http://liike/kuti/#/aikataulupoikkeamat" target="_blank" id="challenge-link">{{ 'Challenge' | translate}}</a>
                  </div>
              </span>
              <br />
          </ng-container>
          <ng-template #noCauseCodes>
            <p>{{ 'No active reason code' | translate }}</p>
          </ng-template>

        <!--<ng-container *ngIf="hasActiveConflictAlarms | applyFunction:alarmOverlaySelectedTrain; else noConflicts">
              <h5>{{ 'Conflicts' | translate }}</h5>
              <div *ngFor="let alarm of getActiveConflictAlarms | applyFunction:alarmOverlaySelectedTrain">
                <div>
                  {{ getTranslatedAlarm | applyFunction:alarm }}
                </div>
              </div>
            </ng-container>
            <ng-template #noConflicts>
                <p>{{ 'No conflicts' | translate }}</p>
            </ng-template>

          <ng-container *ngIf="hasActiveTechnicalAlarms | applyFunction:alarmOverlaySelectedTrain; else noTechnicalAlarms">
              <h5>{{ 'Technical alarms' | translate }}</h5>
              <div *ngFor="let alarm of getActiveTechnicalAlarms | applyFunction:alarmOverlaySelectedTrain">
                <div>
                  {{ getTranslatedAlarm | applyFunction:alarm }}
                </div>
              </div>
          </ng-container>
          <ng-template #noTechnicalAlarms>
              <p>{{ 'No technical alarms' | translate }}</p>
          </ng-template>-->
        </div>
    </div>
</qm-overlay-panel>

<ng-template #conflictIcon>
    <i style="color: var(--color-danger-base)" class="far fa-exclamation-triangle"></i>
</ng-template>
